import { connect } from 'react-redux'
import { notify } from 'actions/account'
import { addGuestPass } from 'actions/account/cart'

const mapStateToProps = ({ cart: { cartForm } }) => ({ cartForm })
const actions = { addGuestPass, notify }

const withRedux = connect(
  mapStateToProps,
  actions
)

export default withRedux
